import React from 'react';
import * as Styled from './ABlockquote.styles';
import type { ABlockquoteProps } from './ABlockquote.types';

const COMPONENT_NAME = 'a-web-ui-kit-ABlockquote';
const TEST_ID = 'web-ui-kit-ABlockquote';

function ABlockquote({ text, ...props }: ABlockquoteProps) {
  return (
    <Styled.Blockquote data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...props}>
      {text}
    </Styled.Blockquote>
  );
}

export { ABlockquote, TEST_ID as A_BLOCKQUOTE_TEST_ID };
